import { useEffect } from "react"
import { useGetUserQuery } from "@/queries/user"
import { useAuthStore } from "@/stores/auth"
import { getInitialLocale, setAppLocale } from "@/i18n"
import { isSupportedLocale } from "@/i18n/locales"

export function LocaleSync() {
  const token = useAuthStore((state) => state.token)
  const storeUser = useAuthStore((state) => state.user)
  const storeLocale = (storeUser as { locale?: string } | null | undefined)?.locale
  const shouldFetchProfile = !!token && !storeLocale
  const { data: userData } = useGetUserQuery({}, { skip: !shouldFetchProfile })

  const user = (userData as { locale?: string } | undefined) ?? undefined
  const userLocale = user?.locale ?? storeLocale

  useEffect(() => {
    if (!userLocale || !isSupportedLocale(userLocale)) return
    const preferred = getInitialLocale(userLocale)
    void setAppLocale(preferred)
  }, [userLocale])

  return null
}
